// extracted by mini-css-extract-plugin
module.exports = {"header":"RegisterHeader_header__N4HAR","headerTitle":"RegisterHeader_headerTitle__3jpWI","headerIcon":"RegisterHeader_headerIcon__1PvSr"};